// FUNCTION TO CALCULATE OVERALL RATING BY PASSING AN ARRAY OF OBJECT WITH KEY `rating`
export function calculateRating(array) {
    const oneStar = array?.filter(v => v?.rating === 1)?.length;
    const twoStar = array?.filter(v => v?.rating === 2)?.length;
    const threeStar = array?.filter(v => v?.rating === 3)?.length;
    const fourStar = array?.filter(v => v?.rating === 4)?.length;
    const fiveStar = array?.filter(v => v?.rating === 5)?.length;
    const oneHalf = array?.filter(v => v?.rating === 1.5)?.length;
    const twoHalf = array?.filter(v => v?.rating === 2.5)?.length;
    const threeHalf = array?.filter(v => v?.rating === 3.5)?.length;
    const fourHalf = array?.filter(v => v?.rating === 4.5)?.length;

    const overallRating = parseFloat((5*fiveStar + 4.5*fourHalf + 3.5*threeHalf + 2.5*twoHalf + 1.5*oneHalf + 4*fourStar + 3*threeStar + 2*twoStar + 1*oneStar) / (fiveStar+fourHalf+threeHalf+twoHalf+oneHalf+fourStar+threeStar+twoStar+oneStar)).toFixed(1);
    return Number(overallRating) ? Number(overallRating) : 0;
}